import { RequestContextType } from "@utils/api-config/RequestContext";
import { ContextOptions } from "@utils/api-config/types";

export function createApiRequestOptions(
	type: RequestContextType = RequestContextType.Default,
	walletId?: string | null
): ContextOptions {
	const requestOptions: ContextOptions = { context: type };
	if (walletId) {
		requestOptions["walletId"] = walletId;
	}
	return requestOptions;
}
